var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 6.06997C13.3237 6.0133 8.40677 5.83622 4.08985 7.69283C3.40767 7.98622 3 8.67763 3 9.42024V14.0001V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V8.08147C21 6.9769 20.1043 6.081 18.9998 6.06997Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.03791V5.0178C19 3.99982 18.2367 3.149 17.2204 3.08923C14.2548 2.91482 8.21868 2.82413 4.07387 4.53199C3.39646 4.81111 3 5.49648 3 6.22914V9.03032",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12H18.5C17.6716 12 17 12.6716 17 13.5V13.5C17 14.3284 17.6716 15 18.5 15H21",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWallet;